import angular from 'angular';
import InputDatepicker from './inputDatepicker/inputDatepicker';
import select from './select/select';
import FormErrorsSummary from './formErrorsSummary/formErrorsSummary';
import Avatar from './avatar/avatar';
import ToggleSwitch from './toggleSwitch/toggleSwitch';
import mainMenu from './mainMenu/mainMenu';
import mainMenuMobile from './mainMenuMobile/mainMenuMobile';
import loading from './loading/loading';
import table from './table/table';
import delegationsList from './delegationsList/delegationsList';
import alertCard from './alertCard/alertCard';
import modalDelegationManager from './modalDelegationManager/modalDelegationManager';
import ModalWarningDelegation from './modalWarningDelegation/modalWarningDelegation';
import employeeDropdownList from './employeeDropdownList/employeeDropdownList';
import employeeSearch from './employeeSearch/employeeSearch';
import confirmCloseModal from './confirmCloseModal/confirmCloseModal';
import cannotSignupModal from './cannotSignupModal/cannotSignupModal';
import successfulAction from './successfulAction/successfulAction';
import failedAction from './failedAction/failedAction';
import cardDetails from './cardDetails/cardDetails';
import questionModal from './questionModal/questionModal';
import optionSwitch from './optionSwitch/optionSwitch';
import modalCoachmark from './modalCoachmark/modalCoachmark';
import employeeName from './employeeName/employeeName';
import floatingActionButtons from './floatingActionButtons/floatingActionButtons';
import tooltipDesktop from './tooltipDesktop/tooltipDesktop';
import tooltipMobile from './tooltipMobile/tooltipMobile';

let componentModule = angular.module('components', [
  InputDatepicker,
  select,
  FormErrorsSummary,
  Avatar,
  ToggleSwitch,
  mainMenu,
  mainMenuMobile,
  table,
  loading,
  delegationsList,
  alertCard,
  modalDelegationManager,
  ModalWarningDelegation,
  employeeDropdownList,
  employeeSearch,
  confirmCloseModal,
  cannotSignupModal,
  successfulAction,
  failedAction,
  cardDetails,
  questionModal,
  optionSwitch,
  modalCoachmark,
  employeeName,
  floatingActionButtons,
  tooltipDesktop,
  tooltipMobile
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js